import {
  accountActivationSendOtpService,
  accountActivationSetPasswordService,
  accountActivationValidateOtpService,
  resendAccountActivationService,
} from '@/services/accountActivation';
import { useMutation } from '@tanstack/react-query';
import { useAuthUser } from '../stores/useAuthUser';

export const useAccountActivationOtp = ({ uuid }: { uuid: string }) => {
  const { isStaff } = useAuthUser();
  const { data, mutateAsync, isPending } = useMutation({
    mutationFn: () =>
      accountActivationSendOtpService({
        activation_code: uuid,
        userGroup: isStaff ? 'staff' : 'teammate',
      }),
  });

  return {
    phoneNumber: data?.phoneNumber,
    getAccountActivationOtp: mutateAsync,
    isLoadingAccountActivationOtp: isPending,
  };
};

export const useAccountActivation = () => {
  const { isPending: isLoadingValidateOtp, mutateAsync: validateOtp } =
    useMutation({
      mutationFn: accountActivationValidateOtpService,
    });

  const { isPending: isLoadingSetPassword, mutateAsync: setPassword } =
    useMutation({
      mutationFn: accountActivationSetPasswordService,
    });

  return {
    isLoadingValidateOtp,
    isLoadingSetPassword,
    validateOtp,
    setPassword,
  };
};

export const useResendActivationStatus = () => {
  const {
    isPending: isLoadingResendActivation,
    mutateAsync: resendActivation,
  } = useMutation({
    mutationFn: resendAccountActivationService,
  });

  return {
    isLoadingResendActivation,
    resendActivation,
  };
};
